import styled from "styled-components";

export const StyledButton = styled("button")<{ color?: string }>`
  background: ${(p) => p.color || "#2e186a"};
  color: ${(p) => (p.color ? "#2E186A" : "#fff")};
  font-size: 1rem;
  font-weight: 700;
  width: 100%;
  border: 2px solid transparent;
  border-radius: 50px;
  padding: 14px 0;
  cursor: pointer;
  margin-top: 0.625rem;
  max-width: 200px;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 8px 24px rgb(23 31 114 / 15%);
  letter-spacing: 0.02em;

  &:hover,
  &:active,
  &:focus {
    color: #fff;
    border: 2px solid rgb(255, 130, 92);
    background-color: rgb(255, 130, 92);
    box-shadow: 0 12px 32px rgb(255 130 92 / 30%);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;
